import axios from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'

const axiosClient = axios.create({
    baseURL: '/v2/api',
})

// Add a request interceptor
axiosClient.interceptors.request.use(async (config) => {
    const session = await fetchAuthSession()
    const token = session.tokens.idToken

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

export default axiosClient
